import Layout from '@/components/layout/index.vue'
export default {
  path: 'orderdelivery',
  name: 'Orderdelivery',
  meta: {},
  component: Layout,
  redirect: { name: 'Orderdelivery.Parameter' },
  children: [
    {
      path: 'parameter',
      name: 'Orderdelivery.Parameter',
      meta: {},
      component: () => import(/* webpackChunkName: "orderdelivery" */ '@/views/purchaser/orderdelivery/parameter/index.vue')
    },
    {
      path: 'tracking',
      name: 'Orderdelivery.Tracking',
      meta: {},
      component: () => import(/* webpackChunkName: "orderdelivery" */ '@/views/purchaser/orderdelivery/tracking/index.ts')
    },
    {
      path: 'orderanswer',
      name: 'Orderdelivery.orderanswer',
      meta: {},
      component: () => import(/* webpackChunkName: "deliverysynergy" */ '@/views/purchaser/orderdelivery/orderanswer/index.ts')
    },
    {
      path: 'deliveryschedule',
      name: 'Orderdelivery.deliveryschedule',
      meta: {},
      component: () => import(/* webpackChunkName: "deliverysynergy" */ '@/views/purchaser/orderdelivery/deliveryschedule/index')
    },
    {
      path: 'newTrace',
      name: 'Orderdelivery.NewTrace', // 新订单追踪路由名称
      meta: {},
      component: () => import(/* webpackChunkName: "deliverysynergy" */ '@/views/purchaser/orderdelivery/newTrace/index.ts')
    },
    {
      path: 'configurationlist',
      name: 'Orderdelivery.configurationlist',
      meta: {},
      component: () => import(/* webpackChunkName: "deliverysynergy" */ '@/views/purchaser/orderdelivery/configurationlist/index.vue')
    },
    {
      path: 'shipmentsConfiguration',
      name: 'Orderdelivery.ShipmentsConfiguration',
      meta: { title: 'common.add', dep: 'Orderdelivery.configurationlist' },
      component: () => import(/* webpackChunkName: "deliverysynergy" */ '@/views/purchaser/orderdelivery/configurationlist/shipmentsConfiguration.vue')
    },
    {
      path: 'lookdajiao',
      name: 'Orderdelivery.Lookdajiao',
      meta: { title: 'common.checkAcceptance', dep: 'Orderdelivery.NewTrace' },
      component: () => import(/* webpackChunkName: "deliverysynergy" */ '@/views/purchaser/orderdelivery/newTrace/lookdajiao.vue')
    },
    {
      path: 'asn',
      name: 'Orderdelivery.asn',
      meta: {},
      component: () => import(/* webpackChunkName: "deliverysynergy" */ '@/views/purchaser/orderdelivery/asn/index.ts')
    },
    {
      path: 'labelprinting',
      name: 'Orderdelivery.labelprinting',
      meta: {},
      component: () => import(/* webpackChunkName: "deliverysynergy" */ '@/views/purchaser/orderdelivery/labelprinting/index.vue')
    },
    {
      path: 'purchaseCallMaterial',
      name: 'Orderdelivery.purchaseCallMaterial',
      meta: {},
      component: () => import(/* webpackChunkName: "deliverysynergy" */ '@/views/purchaser/orderdelivery/purchaseCallMaterial/index.ts')
    },
    {
      path: 'shippingschedule',
      name: 'Orderdelivery.shippingschedule',
      meta: { },
      component: () => import(/* webpackChunkName: "deliverysynergy" */ '@/views/purchaser/orderdelivery/shippingschedule/index.ts')
    }
  ]
}
